<div class="dialog-container">
    <h4 mat-dialog-title class="dialog-title">Delete</h4>
    <div mat-dialog-content class="dialog-content text-muted">Are you sure you want to delete?</div>
    <div mat-dialog-actions class="dialog-actions mt-4 d-flex align-items-center justify-content-end">
        <button mat-button class="cancel-button" (click)="onNoClick()">Cancel</button>
        <button mat-button class="btn btn-danger yes-button" (click)="delete()"
            *ngIf="!isLoading; else loadingTemplate" cdkFocusInitial>Delete</button>
        <ng-template #loadingTemplate>
            <button mat-button class="btn btn-danger yes-button" cdkFocusInitial disabled>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </button>
        </ng-template>
    </div>
</div>